<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/135kW/135kW.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">135kW三合一电驱总成</div>
                <div class="detail-banner-desc transmission">
                    <!-- 国内首款自主研发并产业化的两挡电驱总成 -->
                    <div class="detail-desc">
                        <div>
                            高度集成，结构紧凑，更利于整车搭载；<br />
                        </div>
                        <div>
                            轻量化设计，高扭重比；<br />
                        </div>
                        <div>
                            电机定子低谐波绕组结构，高齿轮重合度≥4.0，NVH性能优异；<br />
                        </div>
                        <div>
                            电机发卡式扁线绕组，高槽满率，高效率轴承，少油量，总成最高效率94%。
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/135kW/135kW-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">135kW</div>
                                    <div class="k">电机峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">16000rpm</div>
                                    <div class="k">电机峰值转速</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2849N·m</div>
                                    <div class="k">峰值输出扭矩</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2</div>
                                    <div class="k">挡位数量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">450*495*295</div>
                                    <div class="k">尺寸 X*Y*Z（mm）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">69kg</div>
                                    <div class="k">重量</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '135kW三合一电驱总成 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/135.html'
};

import { createApp } from 'vue';
import App from './135.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./135.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
